// extracted by mini-css-extract-plugin
export default {"mainContainer":"Login_mainContainer__PF5VE"};